import { request } from '../request';

export const heartbeatApi = {
  getHeartbeatConfig: () => request('/config/heartbeat'),

  updateHeartbeatConfig: (body) =>
    request('/config/heartbeat', {
      method: 'PUT',
      body: JSON.stringify(body)
    })
};
